// Central games data store with all game information
// This provides dynamic data for game listings and detail pages

// Generate unique 10-digit ID
const generateGameId = () => Math.floor(1000000000 + Math.random() * 9000000000).toString()

// All games data
export const gamesData = {
  'neon-pulse-overdrive': {
    id: '4829173650',
    slug: 'neon-pulse-overdrive',
    title: 'Neon Pulse: Overdrive',
    description: 'Experience high-stakes racing through the neon-lit streets of a digital metropolis. Navigate through dynamic traffic, execute precision drifts around tight corners, and boost through straightaways as you compete against players worldwide in this adrenaline-fueled cyberpunk racing experience.\n\nUnlock a garage of futuristic vehicles, each with unique handling and customization options. Master multiple racing modes including time trials, elimination races, and intense multiplayer championships. With stunning visual effects, responsive controls, and an electrifying soundtrack, every race feels like an epic chase scene.',
    shortDescription: 'High-stakes racing through neon streets of a digital metropolis.',
    image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuBl3GSyCUHKJczmptJuHf1XdgUScxH_XQKXZny9uYjQ1YnqynN0TxS0jTPZ9a46y7EyxEUVbpiZ3RU8AApVXDyYHPpvftGrCCC9y9CzgdzyUEh9_Wdkw8YvsRGLbNAC3J-1YX1VJlnNKciDW3zEA8f2whXsz4Mb3ZJNuzb1aMBao_vbCZez1plKzdW1SgYpmG93RSZQ23vAQHJR82cnZjXnVSXcY3bRpQbUfXkGT0bOipBB2DfWOpfbSIrF4feZBSVtfqhtnKC8ga_Y',
    genre: 'Racing',
    tags: ['Racing', 'Combat', 'Multiplayer'],
    features: [
      { icon: 'Gauge', title: 'Hyper-Velocity Physics', description: 'Real-time physics and aerodynamics at smooth 60FPS.' },
      { icon: 'Palette', title: 'Custom Garage', description: 'Modify 50+ unique parts to build your ultimate machine.' },
      { icon: 'Globe', title: 'Global Multiplayer', description: 'Compete in real-time races with players worldwide.' },
      { icon: 'Trophy', title: 'Daily Tournaments', description: 'Win exclusive limited-edition rewards every 24 hours.' }
    ],
    rating: 4.9,
    reviews: '12.4k',
    activePlayers: '2,482',
    badge: 'Editor\'s Choice',
    tag: 'Trending Now',
    playable: false,
    component: null,
    engine: 'WebGL',
    fps: '60',
    plays: '12.4k',
    releaseDate: 'Dec 2024'
  },
  'the-void-quest': {
    id: '5927384610',
    slug: 'the-void-quest',
    title: 'The Void Quest',
    description: 'Explore mysterious dimensions in this epic adventure game where reality bends and ancient secrets await discovery. Battle powerful enemies, solve intricate puzzles, and traverse breathtaking otherworldly landscapes as you unravel a story that spans multiple realms. Each dimension offers unique challenges, hidden treasures, and formidable bosses.\n\nCustomize your hero with upgradeable abilities, legendary weapons, and mystical artifacts. Form alliances with otherworldly beings, make choices that shape the narrative, and discover multiple endings based on your journey. Features an immersive day-night cycle, dynamic weather systems, and a hauntingly beautiful orchestral soundtrack.',
    shortDescription: 'Explore mysterious dimensions in this epic adventure game.',
    image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuCp8tYaQGs7C1ZOp2ni9epiw7aJxQp5rQ9mMRYjwJ4NE8kJ24vYK5Bp4gSMpOe4MNe1r1wzKwyWAu-oX2CL5tncMgIaDD6z4CkSuP1KXIndxQ8Oc-tMqmwCP4_kZ4Fr-VohPGr7BbDg_I9z7_MEPuD5SdMasubp1_cPH14fGI8nnLZektPweqvu6F93eA1D8pU9IaWi4j342g6zPZGc1O5yXZmI3SIwdKXkIKxoQTE0Smpo9MLef1P_ur_LSJvilJbfhmOnRMDUMAOR',
    genre: 'Adventure',
    tags: ['Adventure', 'RPG', 'Story'],
    features: [
      { icon: 'Compass', title: 'Multiple Dimensions', description: 'Explore unique realms with distinct challenges and secrets.' },
      { icon: 'Sword', title: 'Legendary Arsenal', description: 'Upgrade abilities and collect powerful mystical weapons.' },
      { icon: 'GitBranch', title: 'Branching Narrative', description: 'Your choices shape the story with multiple endings.' },
      { icon: 'Trophy', title: 'Epic Boss Battles', description: 'Face formidable bosses guarding hidden treasures.' }
    ],
    rating: 4.7,
    reviews: '8.1k',
    activePlayers: '1,847',
    badge: 'Featured',
    tag: 'New Release',
    playable: false,
    component: null,
    engine: 'Unity',
    fps: '60',
    plays: '8.1k',
    releaseDate: 'Nov 2024'
  },
  'eco-city-tycoon': {
    id: '3847291650',
    slug: 'eco-city-tycoon',
    title: 'Eco City Tycoon',
    description: 'Build and manage your own sustainable metropolis in this immersive city simulation. Balance economic growth with environmental responsibility as you zone residential, commercial, and industrial areas. Implement green energy solutions, manage traffic flow, and keep your citizens happy while growing your city from a small town to a thriving eco-paradise.\n\nResearch cutting-edge sustainable technologies, respond to natural disasters, and handle random events that test your leadership. Features over 100 unique buildings, dynamic economy systems, and realistic population simulation. Challenge yourself with scenarios ranging from transforming polluted cities to building eco-utopias from scratch.',
    shortDescription: 'Build and manage your own sustainable city in this immersive simulation.',
    image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuCZNnOVUHlILjfD30JaqPKw8bo3H4GBOHC1xLtPcrgvHBwfNkf3fe9hEPfriQBrW2mmwhRTzcmbyw6HYwBbE8AKr1bl90FwAMaiOLO69X8dvC-qtJdaXcC_gPmgffu7LB9_0GruVHUFZJxNJlwYq5rVOwBIpk5W4SrUE_rKczEs3jxSHcSpGW-gwRJ0qLsTNdsgv_kjpCRuMJltPLf4EN3yd2WWFas6qMQNhtbOkb4Vzs3AXRNVCHjb6zwIA7jw-8aO12upomZAuHI1',
    genre: 'Simulation',
    tags: ['Simulation', 'Strategy', 'Building'],
    features: [
      { icon: 'Building', title: '100+ Buildings', description: 'Construct residential, commercial, and industrial zones.' },
      { icon: 'TrendingUp', title: 'Dynamic Economy', description: 'Realistic population simulation and market systems.' },
      { icon: 'Leaf', title: 'Green Energy', description: 'Implement sustainable solutions for your eco-city.' },
      { icon: 'Trophy', title: 'Challenge Modes', description: 'Test your skills with unique scenario objectives.' }
    ],
    rating: 4.8,
    reviews: '15.2k',
    activePlayers: '3,291',
    badge: 'Popular',
    tag: 'Popular',
    playable: false,
    component: null,
    engine: 'WebGL',
    fps: 'Uncapped',
    plays: '15.2k',
    releaseDate: 'Oct 2024'
  },
  'titan-battle-arena': {
    id: '7382946150',
    slug: 'titan-battle-arena',
    title: 'Titan Battle Arena',
    description: 'Enter the arena and prove your worth in intense multiplayer combat. Choose from a roster of powerful titans, each with unique abilities, playstyles, and ultimate attacks. Master devastating combo moves, time your blocks perfectly, and climb the competitive ranks to become the ultimate champion in fast-paced 1v1 and team battles.\n\nUnlock new titans through gameplay, customize their appearance with rare skins and effects, and earn rewards in seasonal ranked modes. Features multiple arena environments, weekly tournaments, and a deep progression system. Join guilds, compete in clan wars, and dominate leaderboards with skill-based matchmaking that ensures fair fights.',
    shortDescription: 'Enter the arena and prove your worth in intense multiplayer combat.',
    image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuACCVwnpcIxHYvF5NK9dY9uunSByPcL2SVXu-oBBhk2ENCweqhJ2CDMuHz0Xpc7zHKeYs8ME04D4XmXuEyEVSpZK4mhbO_bwoO2IF9rEJL4ooLNmH50bvhQqDel8M9HnM9AvVBK_0rRhyA0uFmP1z4H4gh4VeKZDY4P82gfe8PRcs0xa1RKG5HpJUawU9VsJmUP6wWp9PAP0Qj3ayvO8bAKyhkgcpT5m3-RfRpUENbb0bjvnRE9czA4EhWbh5xzgVMKFIKDgAI_EtY_',
    genre: 'Action',
    tags: ['Action', 'Combat', 'Multiplayer'],
    features: [
      { icon: 'Shield', title: 'Unique Titans', description: 'Choose from diverse titans with special abilities.' },
      { icon: 'Swords', title: 'Battle Modes', description: 'Compete in intense 1v1 and team battles.' },
      { icon: 'Trophy', title: 'Ranked Seasons', description: 'Climb competitive ranks and earn exclusive rewards.' },
      { icon: 'Users', title: 'Clan Wars', description: 'Join guilds and battle for territory domination.' }
    ],
    rating: 4.9,
    reviews: '22.9k',
    activePlayers: '5,127',
    badge: 'Editor\'s Pick',
    tag: 'Editor\'s Pick',
    playable: false,
    component: null,
    engine: 'WebGL',
    fps: '144',
    plays: '22.9k',
    releaseDate: 'Sep 2024'
  },
  // Playable JS Games
  'tic-tac-toe': {
    id: '1029384756',
    slug: 'tic-tac-toe',
    title: 'Tic Tac Toe',
    description: 'The classic game of X\'s and O\'s reimagined with a clean, modern interface! Challenge a friend in local two-player mode or test your skills against the computer AI. Simple to learn but surprisingly strategic, every move counts as you race to align three symbols in a row, column, or diagonal.\n\nFeatures multiple difficulty levels from easy to unbeatable AI, move tracking, and win streak counters. Perfect for quick gaming sessions, brain training, or settling friendly competitions. Enjoy satisfying animations, clear visual feedback, and instant restarts for endless strategic fun.',
    shortDescription: 'Classic game of X\'s and O\'s - simple yet addictive!',
    image: 'https://images.unsplash.com/photo-1611996575749-79a3a250f948?w=800&auto=format&fit=crop&q=60',
    genre: 'Puzzle',
    tags: ['Puzzle', 'Classic', 'Strategy', '2-Player'],
    features: [
      { icon: 'Users', title: 'Two Player Mode', description: 'Challenge friends in local multiplayer matches.' },
      { icon: 'Bot', title: 'Smart AI', description: 'Multiple difficulty levels from easy to unbeatable.' },
      { icon: 'Trophy', title: 'Win Tracking', description: 'Track your win streaks and statistics.' },
      { icon: 'Zap', title: 'Instant Restart', description: 'Quick restarts for endless strategic fun.' }
    ],
    rating: 4.5,
    reviews: '5.2k',
    activePlayers: '892',
    badge: 'Classic',
    tag: 'Instant Play',
    playable: true,
    component: 'TicTacToe',
    engine: 'React',
    fps: '60',
    plays: '5.2k',
    releaseDate: 'Jan 2024'
  },
  'snake': {
    id: '2938475610',
    slug: 'snake',
    title: 'Snake',
    description: 'Guide your snake to devour food and grow longer in this nostalgic arcade classic! Navigate through the arena, collecting treats that make you grow while avoiding the walls and your own ever-lengthening tail. The longer you survive, the faster and more challenging the game becomes as your snake fills the screen.\n\nCompete for high scores and challenge your reflexes with progressive difficulty that keeps you on edge. Features smooth controls, vibrant visuals, and instant respawn for addictive one-more-try gameplay. Track your personal best, master corner techniques, and see how long you can survive in this timeless gaming experience.',
    shortDescription: 'Eat, grow, and survive in this classic arcade game!',
    image: 'https://images.unsplash.com/photo-1612287230202-1ff1d85d1bdf?w=800&auto=format&fit=crop&q=60',
    genre: 'Arcade',
    tags: ['Arcade', 'Classic', 'Casual'],
    features: [
      { icon: 'Gamepad2', title: 'Responsive Controls', description: 'Snappy input for quick turns and tight movement.' },
      { icon: 'Gauge', title: 'Speed Ramps Up', description: 'The pace increases as you grow, keeping runs intense.' },
      { icon: 'Target', title: 'Precision Gameplay', description: 'Master cornering and routing to survive longer.' },
      { icon: 'Trophy', title: 'High Score Chasing', description: 'Beat your best and climb toward perfect runs.' }
    ],
    rating: 4.6,
    reviews: '7.8k',
    activePlayers: '1,234',
    badge: 'Retro',
    tag: 'Instant Play',
    playable: true,
    component: 'Snake',
    engine: 'React',
    fps: '60',
    plays: '7.8k',
    releaseDate: 'Feb 2024'
  },
  'memory-match': {
    id: '4756382910',
    slug: 'memory-match',
    title: 'Memory Match',
    description: 'Test your memory and concentration by flipping cards to find matching pairs! Start with easier grids and work your way up to challenging layouts that will put your recall abilities to the ultimate test. Remember card positions, develop pattern recognition, and complete each level in the fewest moves possible.\n\nPerfect for all ages, this brain-training game features multiple difficulty levels, colorful card designs, and move counters to track your efficiency. Challenge yourself to beat your personal best, improve cognitive skills, and enjoy satisfying flip animations with every successful match.',
    shortDescription: 'Test your memory by matching pairs of cards!',
    image: 'https://images.unsplash.com/photo-1606167668584-78701c57f13d?w=800&auto=format&fit=crop&q=60',
    genre: 'Puzzle',
    tags: ['Puzzle', 'Memory', 'Casual', 'Kids'],
    features: [
      { icon: 'Layers', title: 'Difficulty Levels', description: 'Start easy and progress to challenging grids.' },
      { icon: 'Target', title: 'Move Tracking', description: 'Count moves and optimize your efficiency.' },
      { icon: 'Brain', title: 'Brain Training', description: 'Improve memory and cognitive skills.' },
      { icon: 'Heart', title: 'Family Friendly', description: 'Perfect for players of all ages.' }
    ],
    rating: 4.4,
    reviews: '3.1k',
    activePlayers: '567',
    badge: 'Brain Training',
    tag: 'Instant Play',
    playable: true,
    component: 'MemoryMatch',
    engine: 'React',
    fps: '60',
    plays: '3.1k',
    releaseDate: 'Mar 2024'
  },
  'breakout': {
    id: '5647382910',
    slug: 'breakout',
    title: 'Breakout',
    description: 'Destroy colorful brick formations with your bouncing ball in this legendary arcade experience! Control your paddle with precision to keep the ball in play, angle your shots strategically, and clear every brick to advance through increasingly challenging levels. Watch bricks shatter satisfyingly as you rack up points and climb the leaderboard.\n\nMaster ball physics, discover power-ups that enhance your paddle or add extra balls, and tackle special brick types that require multiple hits. Features progressive difficulty, score multipliers, and classic arcade sound effects that bring pure nostalgic joy with every session.',
    shortDescription: 'Destroy bricks with your bouncing ball - arcade classic!',
    image: 'https://images.unsplash.com/photo-1550745165-9bc0b252726f?w=800&auto=format&fit=crop&q=60',
    genre: 'Arcade',
    tags: ['Arcade', 'Classic', 'Action'],
    features: [
      { icon: 'Layers', title: 'Multiple Levels', description: 'Progress through increasingly challenging stages.' },
      { icon: 'Zap', title: 'Power-Ups', description: 'Collect enhancements for your paddle and ball.' },
      { icon: 'Trophy', title: 'Score Multipliers', description: 'Chain combos to maximize your points.' },
      { icon: 'Volume2', title: 'Arcade Sounds', description: 'Classic sound effects for nostalgic vibes.' }
    ],
    rating: 4.7,
    reviews: '6.4k',
    activePlayers: '982',
    badge: 'Arcade Legend',
    tag: 'Instant Play',
    playable: true,
    component: 'Breakout',
    engine: 'Canvas',
    fps: '60',
    plays: '6.4k',
    releaseDate: 'Apr 2024'
  },
  'pong': {
    id: '6758493021',
    slug: 'pong',
    title: 'Pong',
    description: 'Experience the game that started it all in this faithful recreation of the legendary arcade classic! Compete against a challenging AI opponent or grab a friend for intense two-player matches. Control your paddle to deflect the ball past your opponent, mastering angles and timing to score points in fast-paced rallies.\n\nFeatures adjustable difficulty levels, responsive paddle controls, and authentic retro sound effects that capture the spirit of arcade gaming. Whether you\'re introducing a new generation to gaming history or reliving nostalgic memories, Pong delivers timeless competitive fun that never gets old.',
    shortDescription: 'The original arcade classic - table tennis action!',
    image: 'https://images.unsplash.com/photo-1511512578047-dfb367046420?w=800&auto=format&fit=crop&q=60',
    genre: 'Arcade',
    tags: ['Arcade', 'Classic', 'Sports', '2-Player'],
    features: [
      { icon: 'Bot', title: 'AI Opponent', description: 'Challenge smart AI with adjustable difficulty.' },
      { icon: 'Users', title: 'Two Player', description: 'Compete with friends in local matches.' },
      { icon: 'Gamepad2', title: 'Smooth Controls', description: 'Responsive paddle movement for precise play.' },
      { icon: 'Volume2', title: 'Retro Audio', description: 'Authentic arcade sounds from gaming history.' }
    ],
    rating: 4.3,
    reviews: '4.5k',
    activePlayers: '654',
    badge: 'Legendary',
    tag: 'Instant Play',
    playable: true,
    component: 'Pong',
    engine: 'Canvas',
    fps: '60',
    plays: '4.5k',
    releaseDate: 'May 2024'
  },
  'car-racing': {
    id: '8392746501',
    slug: 'car-racing',
    title: 'Neon Racer',
    description: 'Race through a stunning neon highway at breakneck speeds in this thrilling endless racer! Weave through traffic, collect points, and push your reflexes to the limit as the speed intensifies. Every run is a new challenge with procedurally generated obstacles and dynamic difficulty that keeps you coming back for one more attempt.\n\nExperience immersive 3D graphics with glowing neon lights, reflective surfaces, and a synthwave-inspired atmosphere. Features smooth responsive controls, satisfying near-miss bonuses, and global leaderboards to compete with players worldwide. How far can you go before the highway claims you?',
    shortDescription: 'High-speed 3D racing through neon highways!',
    image: 'https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7?w=800&auto=format&fit=crop&q=60',
    genre: 'Racing',
    tags: ['Racing', '3D', 'Action', 'Endless'],
    features: [
      { icon: 'Shuffle', title: 'Procedural Generation', description: 'Every run offers unique obstacle patterns.' },
      { icon: 'Gauge', title: 'Dynamic Difficulty', description: 'Speed and challenge increase as you progress.' },
      { icon: 'Zap', title: 'Near-Miss Bonus', description: 'Earn extra points for close calls.' },
      { icon: 'Trophy', title: 'Leaderboards', description: 'Compete globally for the highest scores.' }
    ],
    rating: 4.8,
    reviews: '2.1k',
    activePlayers: '1,234',
    badge: '3D Game',
    tag: 'Instant Play',
    playable: true,
    component: 'CarRacing',
    engine: 'Three.js',
    fps: '60',
    plays: '2.1k',
    releaseDate: 'Feb 2026'
  },
  'car-dodger': {
    id: '7583921064',
    slug: 'car-dodger',
    title: 'Car Dodger',
    description: 'Navigate through heavy traffic on a busy highway from a thrilling top-down perspective! Switch lanes with precision timing, avoid oncoming vehicles, and survive as long as possible while the traffic gets increasingly chaotic. Every second counts as you weave through gaps and rack up distance points.\n\nImmerse yourself in stunning 3D visuals with detailed car models, dynamic shadows, and smooth lane-switching animations. Features progressive difficulty, close-call scoring bonuses, and endless replayability. Perfect your reflexes, learn traffic patterns, and challenge yourself to beat your personal best distance.',
    shortDescription: 'Top-down 3D traffic dodging action!',
    image: 'https://images.unsplash.com/photo-1494976388531-d1058494cdd8?w=800&auto=format&fit=crop&q=60',
    genre: 'Racing',
    tags: ['Racing', '3D', 'Arcade', 'Endless'],
    features: [
      { icon: 'Eye', title: 'Top-Down View', description: 'Strategic perspective for traffic navigation.' },
      { icon: 'Gamepad2', title: 'Lane Switching', description: 'Smooth controls for quick lane changes.' },
      { icon: 'TrendingUp', title: 'Progressive Chaos', description: 'Traffic intensity increases over time.' },
      { icon: 'Trophy', title: 'Personal Bests', description: 'Track and beat your distance records.' }
    ],
    rating: 4.7,
    reviews: '3.2k',
    activePlayers: '1,456',
    badge: '3D Game',
    tag: 'Instant Play',
    playable: true,
    component: 'CarDodger',
    engine: 'Three.js',
    fps: '60',
    plays: '3.2k',
    releaseDate: 'Feb 2026'
  },
  'neon-drift': {
    id: '5739281046',
    slug: 'neon-drift',
    title: 'Neon Drift Run',
    description: 'Drift through an endless neon highway at breakneck speeds in this premium arcade racing experience! Master the art of drifting around traffic, chain together near-misses for score multipliers, and feel the adrenaline rush as dynamic speed ramping pushes you faster and faster. The longer you survive, the more intense the action becomes.\n\nExperience cinematic slow-motion crash replays, stunning neon visual effects, and a pulsing electronic soundtrack that syncs with your gameplay. Features responsive drift controls, combo scoring systems, and global leaderboards. Every run tells a different story in this addictive high-score chaser.',
    shortDescription: 'Premium neon arcade racing with smooth drifting!',
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&auto=format&fit=crop&q=60',
    genre: 'Racing',
    tags: ['Racing', '3D', 'Arcade', 'Neon'],
    features: [
      { icon: 'Gauge', title: 'Drift Mechanics', description: 'Master smooth drifting around traffic.' },
      { icon: 'Zap', title: 'Combo System', description: 'Chain near-misses for score multipliers.' },
      { icon: 'Video', title: 'Crash Replays', description: 'Cinematic slow-motion crash sequences.' },
      { icon: 'Music', title: 'Dynamic Soundtrack', description: 'Pulsing electronic beats sync to gameplay.' }
    ],
    rating: 4.9,
    reviews: '8.4k',
    activePlayers: '3,201',
    badge: 'Premium',
    tag: 'Trending Now',
    playable: true,
    component: 'NeonDrift',
    engine: 'Three.js',
    fps: '60',
    plays: '8.4k',
    releaseDate: 'Feb 2026'
  },
  'sky-stack': {
    id: '6284193750',
    slug: 'sky-stack',
    title: 'Sky Stack 3D',
    description: 'Stack moving platforms as high as possible and build your tower into the clouds! Time your taps with precision to place blocks perfectly aligned with the previous layer. Every misalignment shrinks your next block, so steady hands and perfect timing are essential to reach new heights and beat your personal best.\n\nEarn satisfying perfect-placement bonuses and chain combos for maximum scores. Features a dynamic camera that follows your tower, smooth physics-based block placement, and calming visuals perfect for relaxing gameplay sessions. Compete on global leaderboards and prove you have the steadiest hands in the sky.',
    shortDescription: 'Precision stacking game - stack to the sky!',
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&auto=format&fit=crop&q=60',
    genre: 'Casual',
    tags: ['Casual', '3D', 'Puzzle', 'Relaxing'],
    features: [
      { icon: 'Target', title: 'Perfect Placement', description: 'Earn bonuses for precise block alignment.' },
      { icon: 'Zap', title: 'Combo Chains', description: 'Build multipliers with consecutive perfects.' },
      { icon: 'Video', title: 'Dynamic Camera', description: 'Smooth camera follows your tower upward.' },
      { icon: 'Palette', title: 'Calming Visuals', description: 'Relaxing atmosphere perfect for unwinding.' }
    ],
    rating: 4.8,
    reviews: '5.7k',
    activePlayers: '2,845',
    badge: 'Addictive',
    tag: 'Instant Play',
    playable: true,
    component: 'SkyStack',
    engine: 'Three.js',
    fps: '60',
    plays: '5.7k',
    releaseDate: 'Feb 2026'
  },
  'jump-box': {
    id: '7391824650',
    slug: 'jump-box',
    title: 'Jump Box',
    description: 'Leap between moving platforms and climb as high as possible in this addictive endless jumper! Time your jumps with precision, land on shifting platforms, and maintain your momentum as you ascend through an ever-changing vertical obstacle course. Miss a jump and it\'s game over, so every leap counts.\n\nEnjoy clean minimalist visuals, responsive jump controls, and satisfying physics that make every successful landing feel rewarding. Features score tracking, progressive difficulty as you climb higher, and instant restarts for addictive one-more-try gameplay. Simple to learn, challenging to master.',
    shortDescription: 'Jump between platforms - don\'t fall!',
    image: 'https://images.unsplash.com/photo-1614294149010-950b698f72c0?w=800&auto=format&fit=crop&q=60',
    genre: 'Casual',
    tags: ['Casual', '3D', 'Arcade', 'Endless'],
    features: [
      { icon: 'Move', title: 'Moving Platforms', description: 'Time jumps on constantly shifting blocks.' },
      { icon: 'Gamepad2', title: 'Precision Controls', description: 'Responsive jumping for accurate landings.' },
      { icon: 'TrendingUp', title: 'Rising Difficulty', description: 'Challenge increases as you climb higher.' },
      { icon: 'Palette', title: 'Clean Design', description: 'Minimalist visuals for focused gameplay.' }
    ],
    rating: 4.7,
    reviews: '3.2k',
    activePlayers: '1,890',
    badge: 'New',
    tag: 'Instant Play',
    playable: true,
    component: 'JumpBox',
    engine: 'Three.js',
    fps: '60',
    plays: '3.2k',
    releaseDate: 'Feb 2026'
  }
}

// Helper functions
export const getGameBySlug = (slug) => {
  // Handle slug-id format (e.g., "neon-pulse-overdrive-4829173650")
  if (slug && slug.includes('-')) {
    const parts = slug.split('-')
    const id = parts.pop()
    const slugName = parts.join('-')
    return gamesData[slugName] || null
  }
  return gamesData[slug] || null
}

export const getGameById = (id) => {
  return Object.values(gamesData).find(game => game.id === id) || null
}

// Sort by release date (newest first)
const sortByNewest = (games) => {
  return [...games].sort((a, b) => {
    const dateA = new Date(a.releaseDate || '2020')
    const dateB = new Date(b.releaseDate || '2020')
    return dateB - dateA
  })
}

export const getAllGames = () => sortByNewest(Object.values(gamesData))

export const getFeaturedGames = () => {
  // Curated featured experiences (requested)
  const featuredSlugs = ['car-racing', 'neon-drift', 'pong', 'jump-box']
  const curated = featuredSlugs.map((slug) => gamesData[slug]).filter(Boolean)

  // Fallback: if any are missing, fill with newest playable games
  if (curated.length < 4) {
    const playable = sortByNewest(Object.values(gamesData).filter((g) => g.playable))
    for (const game of playable) {
      if (curated.length >= 4) break
      if (!curated.some((g) => g.slug === game.slug)) curated.push(game)
    }
  }

  return curated.slice(0, 4)
}

export const getPlayableGames = () => 
  sortByNewest(Object.values(gamesData).filter(game => game.playable))

export const getTrendingGames = () => 
  sortByNewest(Object.values(gamesData)).slice(0, 4)

export const getSimilarGames = (currentSlug, limit = 3) => 
  sortByNewest(Object.values(gamesData).filter(game => game.slug !== currentSlug)).slice(0, limit)

export const getGameUrl = (game) => `/game/${game.slug}-${game.id}`

export const getPlayUrl = (game) => `/play/${game.id}`
